import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { getPrimary, getSecondary } from '../styles/colors';
import { moment } from '../containers/App';

const ThemeProvider = ({ children }) => {
	const primary = getPrimary();
	const secondary = getSecondary();

	const theme = createMuiTheme({
		palette: {
			primary: {
				main: primary
			},
			secondary: {
				main: secondary
			}
		},
		typography: {
			fontFamily: ['Lato', 'Roboto', 'Helvetica'],
		},
		overrides: {
			MuiDialog: {
				root: {
					zIndex: 1001,
				}
			},
			MuiDialogTitle: {
				root: {
					fontSize: '0.8rem'
				}
			},
			MuiDrawer: {
				paper: {
					zIndex: 999
				},
				modal: {
					zIndex: 999
				}
			},
			MuiIconButton: {
				root: {
					height: '34px !important'
				}
			},
			MuiInput: {
				underline: {
					'&:hover:not($disabled):before': {
						borderBottom: `2px solid ${secondary}`
					},
					'&:after': {
						borderBottom: `2px solid ${secondary}`
					}
				}
			},
			MuiInputLabel: {
				root: {
					color: secondary
				}
			},
			MuiMenu: {
				paper: {
					zIndex: 998
				}
			},
			MuiMenuItem: {
				root: {
					fontSize: '14px !important'
				}
			},
			MuiSelect: {
				select: {
					fontSize: '15px !important'
				}
			},
			MuiStepper: {
				root: {
					backgroundColor: 'transparent',
				},
				horizontal: {
					height: '6rem',
					overflow: 'hidden',
				}
			},
			MuiTab: {
				root: {
					outline: 'none !important',
					userSelect: 'none !important',
					textTransform: 'none',
					fontWeight: '700',
				},
				'&$disabled': {
					fontWeight: '400'
				},
				label: {
					fontSize: '14px !important',
				},
				'&$selected': {
					fontWeight: '700'
				}
			},
			MuiTable: {
				root: {
					maxWidth: '90%',
					fontSize: '0.8rem'
				}
			},
			MuiTableRow: {
				root: {
					width: '50%'
				}
			},
			MuiTooltip: {
				tooltip: {
					fontSize: '0.7rem'
				}
			},
			MuiTypography: {
				title: {
					fontSize: '1.25rem'
				}
			}
		}
	});

	return (
		<MuiThemeProvider theme={theme}>
			<MuiPickersUtilsProvider moment={moment} utils={MomentUtils}>
				{children}
			</MuiPickersUtilsProvider>
		</MuiThemeProvider>
	);
};

export default ThemeProvider;
